import React, { useState } from "react";
import { useGroups } from "../files/useGroups";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { IconButton } from "../utils/IconButton";
import { faList } from "@fortawesome/free-solid-svg-icons";
import { groupBy } from "../utils/iterable-utils";

export function Navigation() {
    const [showModal, setShowModal] = useState(false);

    return <div className="navigation">
        <div className="mobile">
            <IconButton
                icon={faList}
                text="Go to"
                onClick={() => setShowModal(true)}
            />
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <ModalHeader closeButton>
                    <ModalTitle>Navigate to</ModalTitle>
                </ModalHeader>
                <ModalBody style={{ maxHeight: "80vh", overflowY: "auto" }}>
                    {showModal && <NavList onNavigate={() => setShowModal(false)} />}
                </ModalBody>
            </Modal>
        </div>
        <div className="desktop">
            <NavList />
        </div>
    </div>
}

function NavList(props: { onNavigate?: () => void }) {
    const groups = useGroups();
    const groupsByYear = groupBy(groups, g => g.files.at(-1)?.meta.date.substring(0, 4));

    return <div>
        {groupsByYear.map(year => <div key={year.key}>
            <h3>{year.key}</h3>
            <ul>{year.items.map(x => <li key={x.uid}>
                <a href={`#${x.uid}`} onClick={() => props.onNavigate?.()}>
                    {x.title}
                </a>
            </li>)}</ul>
        </div>)}
    </div>
}
